import { createAction } from './helpers';

export const setOnboardViewed = () => createAction('@onboard/SET_ONBOARD_VIEWED');

export type OnboardActions = ReturnType<typeof setOnboardViewed>;
